import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import logo from "~/assets/i/logo.svg";
const Wrapper = styled.div`
  display: flex;
  justify-content: left;
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref2 => {
  let {
    $color
  } = _ref2;
  return $color && `color: ${$color}`;
}};
`;
const Logo = styled.img`
  margin-right: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing.step;
}}px;
`;
const Branding = _ref4 => {
  let {
    s = {},
    color,
    children,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $color: color,
    $s: s
  }, rest), /*#__PURE__*/React.createElement(Logo, {
    src: logo,
    alt: "Joyn",
    width: 40
  }), /*#__PURE__*/React.createElement("h2", null, "Joyn"));
};
export default Branding;